<section class="row d-block mt-2 formula-table-container">
    <table class="w-100 table">
        <thead>
            <tr>
                <td class="data-entry-col thead period-col" rowspan="3"></td>
                @if (!isForecastedValues()) {
                    <td class="data-entry-col thead evidence-view" rowspan="3"></td>
                }
                <td class="data-entry-col thead" [attr.colspan]="(metricList() ?? []).length * 2">
                    {{ (isForecastedValues() ? "forecasted_values.title_plural" : "data_entry.actual") | translate }}
                </td>
                <td class="data-entry-col thead" [attr.rowspan]="3">{{ "data_entry.calc_actual" | translate }}</td>
                @if (!isForecastedValues()) {
                    <td class="data-entry-col thead" [attr.colspan]="isBounded() ? 2 : 1" [attr.rowspan]="isBounded() ? 1 : 3">
                        {{ "data_entry.target" | translate }}
                    </td>
                }
            </tr>

            <tr>
                @for (metric of metricList(); track $index) {
                    <td class="data-entry-col thead" [attr.colspan]="2">{{ metric.metricNameAE }}</td>
                }
                @if (isBounded()) {
                    <td class="data-entry-col thead" [attr.rowspan]="2">{{ "kpi.lower_limit" | translate }}</td>
                    <td class="data-entry-col thead" [attr.rowspan]="2">{{ "kpi.upper_limit" | translate }}</td>
                }
            </tr>

            <tr class="background-grey-blue">
                @for (metric of metricList(); track $index) {
                    <td class="data-entry-col thead">{{ "communication.difference.new_value" | translate }}</td>
                    <td class="data-entry-col thead">{{ "communication.difference.old_value" | translate }}</td>
                }
            </tr>
        </thead>

        @for (request of processedDataEntryRequests(); let requestIndex = $index; track requestIndex) {
            @let itemsRow = itemsRows()[+requestIndex];
            @let hasItems = isItemsEntry() && itemsRow?.length;
            @let expanded = hasItems && expandedPeriods().has(+requestIndex);
            <tbody class="period-group" [class.striped]="$even">
                @if (!isBounded()) {
                    <tr>
                        <td class="py-2 data-entry-col period-col fw-bold">
                            @if (hasItems) {
                                <adaa-aikpi-period-toggle
                                    [label]="getPeriodLabel(request)"
                                    [expanded]="expandedPeriods().has(+requestIndex)"
                                    (toggled)="togglePeriod(+requestIndex)"
                                />
                            } @else {
                                {{ getPeriodLabel(request) }}
                            }
                        </td>
                        @if (!isForecastedValues()) {
                            <td class="py-2 data-entry-col">
                                <i class="adaa-icon-view1 fs-3 cursor-pointer" role="button" (click)="viewDifferences(request)"></i>
                            </td>
                        }
                        @for (metric of metricList(); let metricIndex = $index; track metricIndex) {
                            @let items = metricItems()[+requestIndex]?.[+metricIndex];
                            <td
                                class="py-2 data-entry-col"
                                dir="ltr"
                                [class.has-diff]="
                                    showOnlyNew() ||
                                    request.metrics?.[+metricIndex]?.wfProcessCtlId ||
                                    request.metrics?.[+metricIndex]?.hasDiff ||
                                    items?.hasDiff
                                "
                            >
                                @if (showNAFlag(+requestIndex, +metricIndex, "new")) {
                                    {{ "N/A" }}
                                } @else {
                                    {{ request.metrics?.[+metricIndex]?.actual }}
                                }
                                &nbsp;
                            </td>

                            <td
                                class="py-2 data-entry-col"
                                dir="ltr"
                                [class.has-diff]="
                                    request.metrics?.[+metricIndex]?.wfProcessCtlId || request.metrics?.[+metricIndex]?.hasDiff || items?.hasDiff
                                "
                            >
                                @if (showNAFlag(+requestIndex, +metricIndex, "old")) {
                                    {{ "N/A" }}
                                } @else {
                                    {{ request.metrics?.[+metricIndex]?.previous }}
                                }
                                &nbsp;
                            </td>
                        }

                        <td class="py-2 data-entry-col" dir="ltr">{{ getCalculation(+requestIndex) }} &nbsp;</td>
                        @if (!isForecastedValues()) {
                            <td class="py-2 data-entry-col" dir="ltr">{{ getUnboundedValue(request) }} &nbsp;</td>
                        }
                    </tr>
                } @else {
                    <tr>
                        <td class="py-2 data-entry-col period-col fw-bold">
                            @if (hasItems) {
                                <adaa-aikpi-period-toggle
                                    [label]="getPeriodLabel(request)"
                                    [expanded]="expandedPeriods().has(+requestIndex)"
                                    (toggled)="togglePeriod(+requestIndex)"
                                />
                            } @else {
                                {{ getPeriodLabel(request) }}
                            }
                        </td>
                        @if (!isForecastedValues()) {
                            <td class="py-2 data-entry-col">
                                <i class="adaa-icon-view1 fs-3 cursor-pointer" role="button"></i>
                            </td>
                        }
                        @for (metric of metricList(); let metricIndex = $index; track metricIndex) {
                            @let items = metricItems()[+requestIndex]?.[+metricIndex];
                            <td
                                class="py-2 data-entry-col"
                                dir="ltr"
                                [class.has-diff]="
                                    showOnlyNew() ||
                                    request.metrics?.[+metricIndex]?.wfProcessCtlId ||
                                    request.metrics?.[+metricIndex]?.hasDiff ||
                                    items?.hasDiff
                                "
                            >
                                @if (showNAFlag(+requestIndex, +metricIndex, "new")) {
                                    {{ "N/A" }}
                                } @else {
                                    {{ request.metrics?.[+metricIndex]?.actual }}
                                }
                                &nbsp;
                            </td>

                            <td
                                class="py-2 data-entry-col"
                                dir="ltr"
                                [class.has-diff]="
                                    request.metrics?.[+metricIndex]?.wfProcessCtlId || request.metrics?.[+metricIndex]?.hasDiff || items?.hasDiff
                                "
                            >
                                @if (showNAFlag(+requestIndex, +metricIndex, "old")) {
                                    {{ "N/A" }}
                                } @else {
                                    {{ request.metrics?.[+metricIndex]?.previous }}
                                }
                                &nbsp;
                            </td>
                        }

                        <td class="py-2 data-entry-col" dir="ltr">{{ getCalculation(+requestIndex) }} &nbsp;</td>
                        @if (!isForecastedValues()) {
                            <td class="py-2 data-entry-col" dir="ltr">{{ getBoundedValue("lower", request) }} &nbsp;</td>
                            <td class="py-2 data-entry-col" dir="ltr">{{ getBoundedValue("high", request) }} &nbsp;</td>
                        }
                    </tr>
                }

                @if (expanded) {
                    <tr>
                        <td class="py-2 period-items" [attr.colspan]="columnCount()">
                            <div class="fw-bold text-primary mb-2">{{ "data_entry.period" | translate }}: {{ getPeriodLabel(request) }}</div>
                            <div class="d-flex flex-column gap-3">
                                @for (row of itemsRow; track row.metric.kpiMetricId) {
                                    <adaa-aikpi-items-view
                                        [title]="getMetricTitle(row.metric)"
                                        [newItems]="row.items.newItems"
                                        [oldItems]="row.items.oldItems"
                                    />
                                }
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        }
    </table>
</section>
